// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import Vuelidate from 'vuelidate'
import VueAlertify from "vue-alertify"
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import './fonts/HELR65W.woff'
import './fonts/Roboto-Regular.woff'

import Keycloak from 'keycloak-js';
import VueJwtDecode from 'vue-jwt-decode';
import apiUrl from './constants.js'
import interceptorsSetup from '../src/config-keycloak/interceptors.js'
var node_datetime = require('node-datetime');

Vue.use(VueAlertify)
Vue.use(VeeValidate)
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(VCalendar)

/* eslint-disable no-new */
if(apiUrl.isKavachLogin){
  let initOptions = {
    url: apiUrl.keycloakUrl, realm: 'xpressbees', clientId: apiUrl.authclientidui , onLoad: 'login-required'
  }
  let keycloak = new Keycloak(initOptions);
  const currentTime = Math.floor(Date.now() / 1000);
  keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
  console.log(auth ? 'Authenticated' : 'Not authenticated');
  // auth = false
    if (!auth) {
      localStorage.clear();
      // window.location.reload();
      sessionStorage.clear()
      keycloak.clearToken()
      keycloak.logout({ redirectUri: `${apiUrl.app_url}` })
    } else {
      localStorage.setItem('refresh_token', keycloak.refreshToken)
      localStorage.setItem('access_token', keycloak.token);
      const decoded = VueJwtDecode.decode(keycloak.token);
      interceptorsSetup()
      new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: {
          App
        }
      });

      setInterval(() => {
        if (!localStorage.getItem('access_token')) {
            localStorage.setItem('access_token', keycloak.token);
        }
    
        const date = new Date(keycloak.tokenParsed.exp * 1000); 
        const date_time = node_datetime.create(date).format('Y-m-d H:M:S');
        //console.log(date_time, keycloak.tokenParsed.exp);
    
        const currentTime = Math.floor(Date.now() / 1000);
    
          if (keycloak.tokenParsed && keycloak.tokenParsed.exp && (keycloak.tokenParsed.exp - currentTime <= 60)) {
              
              keycloak.updateToken(30).then((refreshed) => {
                 if (refreshed) {
                      localStorage.setItem('access_token', keycloak.token);
                  }
              }).catch(error => {
                  console.error('Failed to refresh token', error);
                  localStorage.clear();
                  sessionStorage.clear();
                  keycloak.logout({ redirectUri: `${apiUrl.app_url}` });
              });
          }
  
        //console.log(keycloak.tokenParsed.exp  , currentTime)
        if (keycloak.tokenParsed.exp <= currentTime) {
            console.log('Token expired, logging out user...',node_datetime.create(date).format('Y-m-d H:M:S'));
            localStorage.clear();
            sessionStorage.clear();
            keycloak.logout({ redirectUri: `${apiUrl.app_url}` });
        }
    }, 120000); 
    }
  }, error => {
    console.log(error)
    console.error('Authenticated Failed - ' + error);
  });
}else{
  interceptorsSetup()

  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
      App
    }
  });
}


// WEBPACK FOOTER //
// ./src/main.js